import React from "react";
import { Grid, Header } from "semantic-ui-react";
import CurrencyChart from "../../CurrencyChart";
import Chart from "../../Chart";
import {
  ChartValue,
  InstrumentItem,
  InstrumentValue,
  Slice,
  TkrCusip,
} from "../../../types";
import _ from "lodash";
import styles from "../styles.module.scss";
import { mapToChartValues } from "../../../utils/chartFormat";
import { displaySliceId } from "../../../utils/sliceFormat";

interface Props {
  instrument: InstrumentItem;
  sliceDetails: Slice;
  tkrCusip: TkrCusip;
}

const InstrumentCharts = ({ instrument, sliceDetails, tkrCusip }: Props) => {
  return (
    <Grid columns={"equal"} padded divided>
      <Header as="h2">{`Charts - ${tkrCusip.tkr} - ${
        sliceDetails.date
      } - ${displaySliceId(sliceDetails.id)}`}</Header>
      <Grid.Row className={styles.chart}>
        <Grid.Column>
          <Header as="h3" dividing>
            Position Quantity
          </Header>
          <div id={"position-qty-chart"}>
            {instrument && (
              <Chart
                data={mapToChartValues(
                  instrument["mtm-position-quantity"]?.values
                )}
                projectedData={mapToChartValues(
                  instrument["apex-var-position-quantity"]?.values
                )}
              />
            )}
          </div>
        </Grid.Column>
        <Grid.Column>
          <Header as="h3" dividing>
            Position Amount
          </Header>
          <div id={"position-amount-chart"}>
            {instrument && (
              <CurrencyChart
                data={mapToChartValues(
                  instrument["mtm-position-amount"]?.values
                )}
                projectedData={mapToChartValues(
                  instrument["apex-var-position-amount"]?.values
                )}
              />
            )}
          </div>
        </Grid.Column>
        <Grid.Column>
          <Header as="h3" dividing>
            VAR
          </Header>
          <div id={"instrument-var-chart"}>
            {instrument && (
              <CurrencyChart
                data={mapToChartValues(instrument["var-requirement"]?.values)}
                projectedData={mapToChartValues(
                  instrument["apex-var-requirement"]?.values
                )}
              />
            )}
          </div>
        </Grid.Column>
        <Grid.Column>
          <Header as="h3" dividing>
            MTM
          </Header>
          <div id={"instrument-mtm-chart"}>
            {!_.isEmpty(instrument) && (
              <CurrencyChart
                data={mapToChartValues(instrument["mtm-requirement"]?.values)}
              />
            )}
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default InstrumentCharts;
